export default __webpack_public_path__ + "static/ab-laptop-1-c54cd815a39581ddd28d7a478b258201.jpg";